export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL';
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS';

export const CHANGE_PROFILE_PIC_SUCCESS = 'CHANGE_PROFILE_PIC_SUCCESS';
export const CHANGE_PROFILE_PIC_FAILURE = 'CHANGE_PROFILE_PIC_FAILURE';
export const CHANGE_INSTRUCTOR_SUCCESS = 'CHANGE_INSTRUCTOR_SUCCESS';
export const CHANGE_INSTRUCTOR_FAILURE = 'CHANGE_INSTRUCTOR_FAILURE';

export const CHANGE_EMAIL_SUCCESS = 'CHANGE_EMAIL_SUCCESS'
export const CHANGE_FULLNAME_SUCCESS = 'CHANGE_FULLNAME_SUCCESS'
export const CHANGE_EMAIL_FAILURE = 'CHANGE_EMAIL_FAILURE'
export const CHANGE_FULLNAME_FAILURE = 'CHANGE_NAME_FAILURE'
export const CHANGE_USER_BIO_SUCCESS = 'CHANGE_USER_BIO_SUCCESS'
export const CHANGE_USER_BIO_FAILURE = 'CHANGE_USER_BIO_FAILURE'

export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';

export const RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS';
export const RESEND_OTP_FAILURE = 'RESEND_OTP_FAILURE';

